import { Fragment, useEffect, useRef, useState } from "react";
import { Grid, Button, Typography } from "@mui/material";

import FormOne from "./FormOne";
import FormTwo from "./FormTwo";
import { CreatedAndUpdatedInfo, PageHeader, Paper } from "../../../components";
import Buttons from "./Button";

export default function FormDisplay({
  edit,
  fields,
  setEdit,
  editState,
  setEditState,
  formikProps,
  component,
  campaignID,
  categories,
  location,
  languages,
  percentageSliderValue,
  setPercentageSliderValue,
  dialogDetails,
}) {
  // for (let key of Object.keys(formikProps.values)) {
  //   if (
  //     key !== "audience_group" &&
  //     key !== "brandID" &&
  //     key !== "isEditable" &&
  //     key !== "percentage" &&
  //     key !== "minimumAge" &&
  //     key !== "ID"
  //   ) {
  //     let flag = 0;
  //     let type = typeof formikProps?.values[key]?.value;
  //     let isArray = Array.isArray(formikProps?.values[key]?.value);
  //     if (type === "string") {
  //       if (!!formikProps.values[key].value) {
  //         flag = 1;
  //         setEdit(true);
  //         break;
  //       }
  //     }

  //     if (type === "object" && !isArray) {
  //       for (let obj in formikProps.values[key].value) {
  //         if (!!formikProps.values[key].value[obj]) {
  //           flag = 1;
  //           console.log("inside if");
  //           setEdit(true);
  //           break;
  //         }
  //       }

  //       if (isArray) {
  //         console.log("array");
  //         if (formikProps.values[key].value.length > 0) {
  //           flag = 1;
  //           console.log("inside if");
  //           setEdit(true);
  //           break;
  //         }
  //       }
  //       if (flag === 0) {
  //         setEdit(false);
  //       }
  //     }

  //     console.log(flag);
  //   }
  // }

  let mandatoryFalseCount = 0;

  for (const key in formikProps.values) {
    if (
      formikProps.values.hasOwnProperty(key) &&
      typeof formikProps.values[key] === "object" &&
      formikProps.values[key].hasOwnProperty("mandatory") &&
      formikProps.values[key]?.value !== undefined &&
      formikProps.values[key]?.value !== null &&
      formikProps.values[key]?.value !== "" &&
      formikProps.values[key]?.value.length !== 0 &&
      formikProps.values[key]?.value.min !== ""
    ) {
      if (
        key !== "audience_group" &&
        key !== "percentage" &&
        key !== "approx_mau"
      ) {
        if (formikProps.values[key].mandatory === false) {
          mandatoryFalseCount++;
        }
      }
    }
  }

  let count = useRef(true);

  let [oldMandatoryFalseCount, setOldMandatoryFalseCount] = useState(0);

  return (
    <Fragment>
      <Grid item xs={12}>
        {component !== "dialog" && (
          <PageHeader
            subHeading={"My Audience"}
            twoText={!formikProps.values.ID && true}
            firstText={"Create Audience. "}
            secondText={"Get to them."}
            pageName={
              !!formikProps.values.ID && formikProps.values.audience_group.value
            }
            buttons={[
              component !== "dialog" && (
                <Buttons
                  ID={formikProps.values.ID}
                  formikProps={formikProps}
                  editState={editState}
                  setEditState={setEditState}
                  condition={formikProps.values.isEditable}
                />
              ),
            ]}
          />
        )}
      </Grid>

      <Grid container spacing={8}>
        {component === "dialog" && (
          <Fragment>
            <Grid item xs={6}>
              <Typography
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#02a0fc",
                }}
              >
                Audience Details
              </Typography>
            </Grid>

            <Grid item xs={6} textAlign="end">
              {dialogDetails.open === "create" && (
                <Button
                  size="large"
                  variant="contained"
                  style={{ borderRadius: "40px" }}
                  onClick={formikProps.handleSubmit}
                  disabled={!formikProps.isValid}
                >
                  Save
                </Button>
              )}
            </Grid>
          </Fragment>
        )}

        <Grid item xs={6}>
          <FormOne
            fields={fields}
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
            edit={edit}
            setEdit={setEdit}
            mandatoryFalseCount={mandatoryFalseCount}
            percentageSliderValue={percentageSliderValue}
            count={count}
            setPercentageSliderValue={setPercentageSliderValue}
            oldMandatoryFalseCount={oldMandatoryFalseCount}
            setOldMandatoryFalseCount={setOldMandatoryFalseCount}
          />
        </Grid>

        <Grid item xs={6}>
          <FormTwo
            fields={fields}
            categories={categories}
            location={location}
            languages={languages}
            formikProps={formikProps}
            editState={editState}
            setEditState={setEditState}
            setEdit={setEdit}
            mandatoryFalseCount={mandatoryFalseCount}
            percentageSliderValue={percentageSliderValue}
            count={count}
            setPercentageSliderValue={setPercentageSliderValue}
            oldMandatoryFalseCount={oldMandatoryFalseCount}
            setOldMandatoryFalseCount={setOldMandatoryFalseCount}
          />

          {(formikProps.values.createdBy || formikProps.values.updatedBy) && (
            <Paper>
              <CreatedAndUpdatedInfo formikProps={formikProps} />
            </Paper>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
}
